class WorkbookPreferences {
    private _workbook: WorkbookConfig;

    hideSidebarWhenOpening: KnockoutObservable<boolean>;

    constructor(data, workbook: WorkbookConfig) {
        this._workbook = workbook;
        this.hideSidebarWhenOpening = ko.observable(data?.hideSidebarWhenOpening ?? false);

        this.setupSettings();
    }

    private setupSettings() {
        this.createSettingItem(this.hideSidebarWhenOpening);
    }

    private createSettingItem(property: KnockoutObservable<any>) {
        let self = this;
        property.subscribe(function (newValue) {
            self.saveSettings();
        });
    }
    private saveSettings(successFunction: () => void = null) {
        let submitObject = {
            workbookId: this._workbook.workbookId(),
            preferences: {
                hideSidebarWhenOpening: this.hideSidebarWhenOpening()
            }
        };

        let o = {
            url: urlConfigs.tabs + "SaveWorkbookPreferences",
            data: submitObject,
            dataType: "json",
            async: true
        } as RequestServerParams;
        o.successFunction = function () {
            if (successFunction) {
                successFunction();
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save workbook preferences`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };
        irGlobal.requestServer(o);
    }
}